var ChatbotComponent = /** @class */ (function () {
    function ChatbotComponent() {
    }
    ChatbotComponent.prototype.ngOnInit = function () {
    };
    return ChatbotComponent;
}());
export { ChatbotComponent };



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.ts.pre-build-optimizer.js